import { Record, Map as ImmutableMap } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as WhileLoopActionMetadataKeys from 'automation-ui-action-features/actions/while-loop/WhileLoopActionMetadataKeys';
import TimeDelay from 'automation-ui-flow-core/fields/time/TimeDelay';
import * as ChronoUnit from 'automation-ui-flow-core/fields/time/ChronoUnit';
export default class WhileLoopActionMetadata extends Record({
  [WhileLoopActionMetadataKeys.ACTION_TYPE]: ActionTypes.WHILE_LOOP,
  [WhileLoopActionMetadataKeys.MAX_NUMBER_OF_ITERATIONS]: 10,
  [WhileLoopActionMetadataKeys.DELAY_BETWEEN_LOOPS]: null
}, 'WhileLoopActionMetadata') {
  constructor(options) {
    const optionMap = ImmutableMap(options);
    const delayBetweenLoops = optionMap.get(WhileLoopActionMetadataKeys.DELAY_BETWEEN_LOOPS) || {
      timeUnit: ChronoUnit.MINUTES,
      delta: 5
    };
    super(optionMap.set(WhileLoopActionMetadataKeys.DELAY_BETWEEN_LOOPS, new TimeDelay(delayBetweenLoops)));
  }
  getDelayBetweenLoops() {
    return this.get(WhileLoopActionMetadataKeys.DELAY_BETWEEN_LOOPS);
  }
  setDelayBetweenLoops(newDelay) {
    return this.set(WhileLoopActionMetadataKeys.DELAY_BETWEEN_LOOPS, newDelay);
  }
  getMaxNumberOfIterations() {
    return this.get(WhileLoopActionMetadataKeys.MAX_NUMBER_OF_ITERATIONS);
  }
  setMaxNumberOfIterations(newMaxNumberOfIterations) {
    return this.set(WhileLoopActionMetadataKeys.MAX_NUMBER_OF_ITERATIONS, newMaxNumberOfIterations);
  }
}